// .pen: yuvk7 (ds/selfie/ai-verdict)
import { Sparkle, TrendDown, TrendUp } from '@phosphor-icons/react';

import { Badge } from '../../ui/Badge';
import pt from '../../../locales/pt';
import { buildVerdictMeta, firstVerdictParagraph } from '../../../lib/reportUiUtils';
import { ReportMetaChip } from './ReportPrimitives';

const TONE_META = {
  positive: { status: 'sage', icon: TrendUp, label: pt.snapshots.report.verdictPill.good },
  mixed: { status: 'sage', icon: TrendUp, label: pt.snapshots.report.verdictPill.mixed },
  cautious: { status: 'warning', icon: TrendDown, label: pt.snapshots.report.verdictPill.attention },
};

function metaChipTone(tone) {
  if (tone === 'caution') return 'caution';
  if (tone === 'positive') return 'positive';
  return 'neutral';
}

/**
 * .pen: yuvk7 (ds/selfie/ai-verdict) — Camada 1, veredito do consultor IA.
 */
export function SelfieReportVerdictBubble({ verdict, report }) {
  if (!verdict?.headline) return null;

  const toneKey = verdict.tone === 'cautious' ? 'cautious' : verdict.tone === 'positive' ? 'positive' : 'mixed';
  const tone = TONE_META[toneKey];
  const ToneIcon = tone.icon;
  const subtext = firstVerdictParagraph(verdict.body);
  const meta = buildVerdictMeta(report);
  const metaLabels = pt.snapshots.report.meta;

  return (
    <section
      aria-labelledby="report-verdict-heading"
      className="flex flex-col gap-space-4 rounded-ds-lg border border-sage-border bg-card p-space-5 shadow-sm"
    >
      <div className="flex items-center gap-space-3">
        <div className="relative flex h-[52px] w-[52px] shrink-0 items-center justify-center">
          <span className="absolute inset-0 rounded-full bg-sage-glow-soft blur-lg" aria-hidden />
          <span className="relative flex h-10 w-10 items-center justify-center rounded-full border border-sage-border bg-sage-tint text-sage-on-tint">
            <Sparkle className="h-5 w-5" aria-hidden />
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-type-label-lg font-semibold text-foreground">
            {pt.snapshots.report.layers.consultantName}
          </p>
          <p className="text-type-chip text-muted-foreground">Análise gerada por IA</p>
        </div>
        <Badge status={tone.status} className="shrink-0">
          <ToneIcon className="h-2.5 w-2.5" aria-hidden />
          {tone.label}
        </Badge>
      </div>

      <div>
        <h2
          id="report-verdict-heading"
          className="text-type-title-page font-semibold leading-snug tracking-tight text-foreground text-balance"
        >
          {verdict.headline}
        </h2>
        {subtext ? (
          <p className="mt-space-3 text-type-body leading-relaxed text-muted-foreground">{subtext}</p>
        ) : null}
      </div>

      {meta.length ? (
        <div className="flex flex-wrap items-center gap-space-2 border-t border-border pt-space-4">
          {meta.map((chip) => (
            <ReportMetaChip
              key={chip.key}
              icon={chip.key === 'patrimonio' ? TrendUp : undefined}
              label={metaLabels[chip.labelKey]}
              value={
                chip.key === 'streak'
                  ? metaLabels.streakUnit.replace('{n}', chip.value)
                  : chip.value
              }
              tone={metaChipTone(chip.tone)}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
}

export default SelfieReportVerdictBubble;
